// Library Imports
import * as React from "react";
import { Grid, Stack, Link, Typography } from "@mui/material";

interface Props {
  claimNumber: string;
  claimStatus: string;
  claimType: string;
  handleBackToClaimList: () => void;
  handleSaveDraft: () => void;
  handleContinue: () => void;
  handleClaimReview: () => void;
}

const ClaimBuilderHeader: React.FC<Props> = ({
  claimNumber,
  claimStatus,
  claimType,
  handleBackToClaimList,
  handleSaveDraft,
  handleContinue,
  handleClaimReview,
}) => {
  return (
    <Grid container className="panel-container" borderRadius={"4px"}>
      <Grid item xs={12}>
        <Grid container className="panel-show-container">
          <Grid container className="panel-information-container">
            <Grid container direction="row" className="admin-header">
              <Grid item xs={12} className="box-header">
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  paddingX={3}
                  paddingY={2}
                  alignItems={"center"}
                  display={"flex"}
                  spacing={0}
                >
                  <Grid item>
                    <Typography
                      className="panel-header"
                      sx={{ fontSize: "21px", fontWeight: 700 }}
                    >
                      Claim Builder - Charge Lines and Additional Details
                    </Typography>
                    {claimNumber ? (
                      <Typography
                        sx={{
                          color: "#707070",
                          fontSize: "16px",
                          fontWeight: 500,
                          lineHeight: "22px",
                          letterSpacing: "1px",
                        }}
                      >
                        Claim Type: {claimType || "N/A"} • Claim #{claimNumber}
                      </Typography>
                    ) : (
                      <Typography
                        sx={{
                          color: "#707070",
                          fontSize: "16px",
                          fontWeight: 500,
                          lineHeight: "22px",
                          letterSpacing: "1px",
                        }}
                      >
                        Claim Type: {claimType || "N/A"}
                      </Typography>
                    )}
                  </Grid>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <Link
                      onClick={handleBackToClaimList}
                      className=""
                      sx={{
                        textDecoration: "underline",
                        color: "#4A4442",
                        marginTop: "10px",
                      }}
                    >
                      Back to Claim List
                    </Link>
                    {claimStatus !== "submitted" &&
                      claimStatus !== "pending_submission" && (
                        <Link
                          onClick={handleSaveDraft}
                          className="basic-button generate-pdf orange-btn"
                        >
                          Save as draft
                        </Link>
                      )}
                    <Link
                      onClick={
                        claimStatus === "submitted" ||
                        claimStatus === "pending_submission"
                          ? handleClaimReview
                          : handleContinue
                      }
                      className="basic-button generate-pdf orange-btn"
                    >
                      {claimStatus === "submitted" ||
                      claimStatus === "pending_submission"
                        ? "Claim Review"
                        : "Continue"}
                    </Link>
                  </div>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ClaimBuilderHeader;
